var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrategizeDevelopmentProcess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 115.43 115.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2,.cls-3{fill:#fff;}.cls-3{opacity:.47;}.cls-4{opacity:.8;}.cls-5{fill:#7da2fe;stroke-linejoin:round;}.cls-5,.cls-6{stroke:#fff;stroke-linecap:round;stroke-width:2px;}.cls-7{fill:#020004;opacity:.15;}.cls-8,.cls-6{fill:none;}.cls-6{stroke-miterlimit:10;}.cls-9{fill:url(#linear-gradient-3);}.cls-10{fill:url(#linear-gradient);}.cls-11{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 57.55,
    y1: 58.58,
    x2: 112.8,
    y2: 1.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 56.52,
    y1: 57.79,
    x2: 1.28,
    y2: 115.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 33.04,
    y1: 78.79,
    x2: 82.39,
    y2: 78.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 25.39,
    y1: 97.39,
    x2: 90.04,
    y2: 97.39,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.5,
    y: 0.5,
    width: 57.71,
    height: 57.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.71,1V57.71H1V1H57.71m1-1H0V58.71H58.71V0h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 57.71,
    y: 1,
    width: 56.71,
    height: 56.71
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.43,1V57.71H57.71V1h56.71m1-1H56.71V58.71h58.71V0h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 57.21,
    y: 57.21,
    width: 57.71,
    height: 57.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.43,57.71v56.71H57.71V57.71h56.71m1-1H56.71v58.71h58.71V56.71h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 57.71,
    width: 56.71,
    height: 56.71
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.71,57.71v56.71H1V57.71H57.71m1-1H0v58.71H58.71V56.71h0Z"
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M92.87,97.98v.14c0,2.5-2.04,4.52-4.54,4.52H22.39c-2.5,0-4.54-2.03-4.54-4.52v-.14c0-2.31,1.73-4.19,3.96-4.47-.29-.21-.48-.53-.48-.9,0-.63,.5-1.13,1.13-1.13,2.15,0,3.96-.56,5.39-1.68,2.27-1.74,3.26-4.59,3.7-6.67,.08-.37,.14-.73,.19-1.08h-1.16v-1.56h-.74c-1.87,0-3.38-1.52-3.38-3.38s1.51-3.38,3.38-3.38h.74v-1.58h3.47c1.76-11.05,12.22-20.33,18.71-26.06,1.86-1.63,3.44-3.04,4.23-3.98,1.86-2.23,1.74-4.88,1.29-6.8-.24,.45-.52,.97-.86,1.58-1.83,3.28-6.1,3.02-9.23,2.83-1.24-.08-3.11-.19-3.5,.15-.43,.37-.6,.77-.82,1.27-.71,1.61-1.56,2.84-5.51,2.84-4.99,0-6.56-5.16-6.7-7.87-.01-.28,.07-.55,.25-.78l15.34-18.84-.98-11.14c-.02-.32,.08-.62,.29-.86s.52-.36,.83-.36c5.14,0,8.19,4.88,9.39,7.3l1.94-1.36c.27-.19,.61-.26,.92-.17,.09,.01,2.05,.53,4.9,1.71,.51,.21,.79,.77,.66,1.31l-.52,2.17,.62,.32,1.86-1.74c.35-.34,.88-.41,1.31-.18,1.73,.93,3.28,1.9,4.73,2.96,.37,.27,.54,.75,.42,1.2l-.59,2.08,.93,.71,1.64-1.01c.43-.27,.99-.21,1.36,.14,1.14,1.06,2.21,2.24,3.16,3.49,.28,.36,.32,.87,.07,1.26l-.56,.93,.73,1.58,1.28-.17c.46-.04,.92,.18,1.15,.61,.77,1.5,1.4,3.11,1.86,4.81,.12,.46-.04,.95-.44,1.22l-1.24,.88,.25,1.28c.32-.03,.66-.07,1.02-.09,.61-.05,1.14,.39,1.2,.99,.1,.92,.16,1.88,.16,2.94,0,1.23-.11,2.45-.33,3.62-.08,.43-.39,.78-.81,.89l-1.16,.32-.08,.51h.29c.35,.02,.68,.19,.88,.47,.2,.28,.26,.64,.17,.97-.38,1.34-.87,2.64-1.29,3.74-.5,1.28-1.05,2.58-1.61,3.91-2.16,5.11-4.57,10.83-5.21,18.46h3.68v1.58h.74c1.87,0,3.38,1.51,3.38,3.38s-1.51,3.38-3.38,3.38h-.74v1.56h-1.16c.04,.34,.11,.7,.19,1.07,.43,2.09,1.42,4.95,3.7,6.7,1.43,1.1,3.24,1.67,5.39,1.67,.62,0,1.13,.5,1.13,1.13,0,.37-.2,.69-.48,.9,2.22,.28,3.96,2.16,3.96,4.47Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M81.66,48.68l-.34,2.2,1.39,.05c-.31,1.08-.7,2.15-1.12,3.24-2.4,6.17-6.11,12.72-6.27,23.04H39.55c0-13.58,16.98-24.79,20.38-28.86,3.16-3.81,.82-8.69,.49-9.33-.01,.19-.26,.92-1.74,3.55-2.15,3.85-9.4,.91-11.09,2.38-1.7,1.47-.34,3.4-4.98,3.4s-4.95-6.04-4.95-6.04l13.89-17.06-.91-10.3c5.32,0,7.93,7.02,7.93,7.02l2.71-1.92s1.72,.44,4.21,1.48l-.64,2.69,1.87,.97,2.17-2.04c1.32,.71,2.71,1.55,4.08,2.55l-.7,2.5,1.92,1.46,2.04-1.27c.96,.9,1.87,1.9,2.7,2.98l-.78,1.29,1.19,2.54,1.86-.24c.65,1.26,1.18,2.62,1.58,4.08l-1.63,1.15,.51,2.66s.91-.09,1.8-.16c.09,.8,.13,1.63,.13,2.49,0,1.04-.09,2.06-.27,3.05l-1.66,.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M57.71,97.99h-24.68c0-11.4,11.14-20.77,24.68-20.77s24.68,9.38,24.68,20.77h-24.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M86.95,92.56H28.48c2.33,0,4.09-.67,5.41-1.69,2.2-1.69,3.2-4.35,3.65-6.52,.34-1.62,.37-2.95,.37-3.4v-.16h39.62v.17c0,.45,.03,1.78,.36,3.38,.45,2.17,1.45,4.84,3.66,6.54,1.32,1.01,3.07,1.68,5.4,1.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35.7,
    y: 74.39,
    width: 44.04,
    height: 8.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68.56,34.69c10.26,4.49,7.7,19.97,0,33.06"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 33.04,
    y: 76.79,
    width: 49.36,
    height: 4,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.39,76.79c1.1,0,2,.9,2,2s-.9,2-2,2H35.04c-1.1,0-2-.9-2-2s.9-2,2-2h45.36m0-1H35.04c-1.65,0-3,1.35-3,3s1.35,3,3,3h45.36c1.65,0,3-1.35,3-3s-1.35-3-3-3h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 25.39,
    y: 94.31,
    width: 64.64,
    height: 6.17,
    rx: 3.02,
    ry: 3.02
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.01,94.31c1.67,0,3.02,1.35,3.02,3.02v.12c0,1.67-1.35,3.02-3.02,3.02H28.42c-1.67,0-3.02-1.35-3.02-3.02v-.12c0-1.67,1.35-3.02,3.02-3.02h58.59m0-1H28.42c-2.22,0-4.02,1.8-4.02,4.02v.12c0,2.22,1.8,4.02,4.02,4.02h58.59c2.22,0,4.02-1.8,4.02-4.02v-.12c0-2.22-1.8-4.02-4.02-4.02h0Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategizeDevelopmentProcess);
export default __webpack_public_path__ + "static/media/strategize-development-process.106bc869070e1ec7c1402c4dd887e91f.svg";
export { ForwardRef as ReactComponent };